<div [formGroup]="form" class="template-config-form-container">
  <gb-form-field [control]="form.controls.name" labelTranslateKey="PRESENTER.TEMPLATE_NAME"></gb-form-field>
  <gb-form-field
    [control]="form.controls.description"
    labelTranslateKey="PRESENTER.TEMPLATE_DESCRIPTION"
    type="textarea"
  ></gb-form-field>

  @if (displayPermissions) {
    <gb-staff-only-options>
      <div class="who-can-view-container">
        <span class="label" translate="PRESENTER.WHO_CAN_VIEW"></span>

        <mat-radio-group formControlName="visibility">
          <mat-radio-button value="public" translate="PRESENTER.VISIBILITY_PUBLIC"></mat-radio-button>
          <mat-radio-button value="client_account" translate="PRESENTER.VISIBILITY_CLIENT_ACCOUNT"></mat-radio-button>
        </mat-radio-group>

        @if (form.controls.visibility.value === 'client_account') {
          <gb-client-account-select
            [multiple]="true"
            [showAccountType]="true"
            formControlName="clientAccounts"
          ></gb-client-account-select>
        }

        @if (showDistributorWarning$ | async) {
          <gb-warning warningType="information"><span translate="PROJECTOR.DIST_WARNING"></span></gb-warning>
        }
      </div>
    </gb-staff-only-options>
  }
</div>
